import axios from "axios";

import SignOut from "../components/SignIn/SignOut";
const store = require("store");

const getPMSDetails = async () => {
  const getPMS = `/pms`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3015 + getPMS,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateMileStoneByRef = async (ref, params) => {
  const updateMileStone = `/pms/${ref}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3015 + updateMileStone,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const addMileStoneByRef = async (ref, params) => {
  const addMileStone = `/pms/${ref}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3015 + addMileStone,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const deleteMileStoneByRefAndSeq = async (ref, seq, params) => {
  const delMileStone = `/pms/${ref}/${seq}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "delete",
      url: process.env.REACT_APP_API_URL_3015 + delMileStone,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export {
  getPMSDetails,
  updateMileStoneByRef,
  addMileStoneByRef,
  deleteMileStoneByRefAndSeq,
};
